import { render, staticRenderFns } from "./clientFission.vue?vue&type=template&id=74f50a90&scoped=true"
import script from "./clientFission.vue?vue&type=script&lang=js"
export * from "./clientFission.vue?vue&type=script&lang=js"
import style0 from "./clientFission.vue?vue&type=style&index=0&id=74f50a90&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f50a90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74f50a90')) {
      api.createRecord('74f50a90', component.options)
    } else {
      api.reload('74f50a90', component.options)
    }
    module.hot.accept("./clientFission.vue?vue&type=template&id=74f50a90&scoped=true", function () {
      api.rerender('74f50a90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/clientAnddistributionChild/clientFission.vue"
export default component.exports